import React from 'react'
import Shared from '../../asset/shared.png'
import Edit from '../../asset/pencil.png'
import Delete from '../../asset/bin.png'
import Close from '../../asset/close.png'
import WindIcon from '../../asset/Wind-Icon.png'
import Elevation from '../../lib/api/elevation'
import { store } from '../../lib/store'
import { decimalToDMS, dateConvertion } from '../main-ui/common/commonfunctions'
import elevation from '../../lib/api/elevation'
import LayerNodeDescription from '../main-ui/left-toolbar/layers/layer/tooltip'
import { createRoot } from 'react-dom/client'

const alertContainer = document.createElement('div');
alertContainer.id = 'infobox-custom-image-popup';
document.body.appendChild(alertContainer);

function hideAlert() {
  const alertBox = document.querySelector('.custom-alert-content');
  if (alertBox) {
    alertBox.remove();
  }
}

// Function to show the alert box
function showAlert(photo, date) {
  const dateTime = new Date(date);
  const dateOnly = dateTime.toLocaleDateString(); // This will give "8/5/2024" (or depending on your locale)

  const alertBox = document.createElement('div');
  alertBox.classList.add('custom-alert-content');
  alertBox.innerHTML = `
        <span class="close-btn" onclick="hideAlert()">&times;</span>
        <div class='infobox-custom-image-popup'>
            <div style="width:55%;height:30px">
                <a id="close">
                    <img id="close-btn" style="width: 5%; height: 50%; object-fit: cover; float: right;"
                        src=${Close} alt="Edit"></img>
                </a>
            </div>
            <img src=${photo.imageUrl} onclick="event.stopPropagation()" style="min-width:500px; max-width:900px; max-height:70vh; border: 2px solid green;"></img>
            <h3 class="photo-model-title">${photo.name} - ${dateOnly}</h3>
        </div>
       `;
  alertContainer.appendChild(alertBox);
  // Add event listener programmatically
  alertBox.querySelector('#close-btn').addEventListener('click', hideAlert);
}

export function createContent(data, callback, dispatchFunction) {
  let { mapReference, mapObj, mapPhotoObj, marker, photo, infoWindow, openInfoWindowClose, token } = data;
  let { editFunction, deleteFunction, closeFunction, updateInfoWindow, editHuntWind } = callback
  let newInfoWindow
  let colorMarker;
  let imageUrl

  const reduxState = store.getState();
  const { userPreferences } = reduxState;
  if (marker) {
    let color = marker.color
    let url = marker.markerType.vectorIconUrl
    const hasSpaces = url.includes(' ');
    if (color) {
      if (color.length <= 6) {
        colorMarker = color[0] == '#' ? color : '#' + color;
      } else {
        colorMarker = color[0] == '#' ? color : '#' + color.substring(color.length == 7 ? 1 : 2);
      }
    } else {
      colorMarker = '#9ecc3b';
    }

    imageUrl = hasSpaces ? url.replace(/\s/g, '%20') : url;
  }

  const infoWindowContent = (value, handleEdit) => {
    let elevation
    if (value) {
      Elevation.getElevation(value.latitude, value.longitude, token)
        .then(res => {
          elevation = res
        })
        .catch(() => {
          console.error('Unable to get photo altitude for:', value.latitude, value.longitude, token)
        })
    }

    const infoWindowElement = document.querySelector('.gm-style-iw-c');

    // Check if the element exists and meets the condition
    function editFunctionCb() {
      editFunction(newInfoWindow)
    }

    function deleteFunctionCb(value) {
      deleteFunction(value.id)
    }

    function editHuntFunctionCb() {
      editHuntWind(newInfoWindow)
    }

    function sendEmail(latitude, longitude, markerName, markerDetails) {
      const domain = process.env.NODE_ENV === 'production' && process.env.__NOTIFICATION_ENV__ == 'production' ? 'app.basemap.com' : 'staging.basemap.com'
      // Define email details
      const to = '';
      const subject = 'BaseMap Shared Marker';
      const body = `I've shared a marker with you, click below to view in the BaseMap app. https://${domain}/marker?latitude=${latitude}&longitude=${longitude}&t=63&n=${markerName}&c=${markerDetails} Don't have the app? Download here: https://app.basemap.com.`;

      // Create a mailto URL
      const mailtoURL = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

      // Open the default email client with the predefined details
      window.location.href = mailtoURL;
    };

    let latitude = userPreferences.coordinates == "dms" ? decimalToDMS(value.latitude.toFixed(5), true) : value.latitude.toFixed(5)
    let longitude = userPreferences.coordinates == "dms" ? decimalToDMS(value.longitude.toFixed(5), false) : value.longitude.toFixed(5)
    let altitudeValue = userPreferences.units == 'imperial' ? (value.altitude * 3.28084).toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' ' + 'ft' : value.altitude.toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' ' + 'm';

    const inputDate = value.created;

    // Format the date
    const formattedDate = dateConvertion(inputDate)
    // Create the container div
    const container = document.createElement('div');
    container.style = `padding: 10px; height: 165px; width: ${marker && (marker.markerType.usageFlag == 3) ? "280px" : "260px"}; background-color: black ; visibility: visible; border-radius:10px`;
    // Apply the style conditionally
    if (infoWindowElement) {
      if (marker && (marker.markerType.usageFlag == 3)) {
        infoWindowElement.style.left = '120px';
      } else {
        // Reset or apply different styles if the condition is not met
        infoWindowElement.style.left = '150px'; // or any other default value
      }
    }

    // Create the content HTML
    container.innerHTML = marker && (marker.markerType.usageFlag == 3) ?
      //this code is to create HUnt Stands  info windows
      `
      <div class="info-window-header-container">
        <div id="my-react-component-container" style="width: 90%"></div>
        <div class="info-window-closeicon">
          <a id="close">
              <img style="width: 20px; object-fit: cover; float: right;  margin-top: -10px; " src=${Close}
                  alt="Edit"></img>
          </a>
        </div> 
      </div>         
                   
      <div style="width: 100%; display: flex; position: relative; z-index: 111;">                
          <div style="width: 70%; ">
              <h6 class="info-box-head-date">Created: <span class="info-box-head-date">${formattedDate}</span></h6>
              <h6 class="info-box-head">Elev: <span class="info-box-span">${altitudeValue}</span></h6>
              <h6 class="info-box-head">Lattitude: <span class="info-box-span">${latitude}</span></h6>
              <h6 class="info-box-head">Longitude: <span class="info-box-span">${longitude}</span></h6>        
              <div style="width:100%; display:flex; margin-top:10px; margin-right:10px;">
                  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="shareButton">
                          <div class="info-window-bottons ">
                              <img style="width: 50%; height: 50%; object-fit: cover;" src=${Shared}></img>
                          </div>
                      </a>
                      <p style="height: 15px;font-size:10px">Share</p>
                  </div>
                  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="editButton">
                          <div class="info-window-bottons " >
                              <img style="width: 50%; height: 50%; object-fit: cover;" src=${Edit} alt="Edit"></img>
                          </div>
                      </a>
                      <p style="height: 15px;font-size:10px">Edit</p>
                  </div>
                  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="editHuntWind">
                          <div class="info-window-bottons ">
                              <img style="width: 50%; height: 50%; object-fit: cover;" src=${WindIcon}></img>
                          </div>
                      </a>
                      <p style="height: 15px; font-size:10px;">Hunt Wind</p>
                  </div>
                  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="deleteButton">
                          <div class="info-window-bottons ">
                              <img style="width: 50%; height: 50%; object-fit: cover;" src=${Delete}></img>
                          </div>
                      </a>
                      <p style="height: 15px;font-size:10px">Delete</p>
                  </div>
              </div>                
          </div>        
          <div style="width: 30%;
                      display: flex;
                      justify-content: center;
                    ">        
              <svg class="info-marker-default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Define the clipping path for the circle -->
                  <defs>
                      <clipPath id="circleClip">
                          <circle cx="8" cy="6" r="5" />
                      </clipPath>
                  </defs>
                  <rect width="16" height="16" id="icon-bound" fill="none"></rect>
                  <path
                      d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
                      fill='${colorMarker ? colorMarker : ' #ffffff'}'></path>
                  <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
                  <!-- Image inside the circle with clipping path -->
                  <image xlink:href=${imageUrl ? imageUrl
        : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} x="4" y="1.5"
                      width="8" height="8" clip-path="url(#circleClip)"></image>
              </svg>
          </div>
      </div>                                    
      <div class="triangle-container">
          <div class="triangle-shape" style="margin-bottom: 3px;"></div>
      </div>   
      `
      :
      //this code is for creating Markers and Photo info windows
      `
      <div class="info-window-header-container">      
        <div id="my-react-component-container" style="width: 90%"></div>
        <div class="info-window-closeicon">
          <a id="close">
              <img style="width: 20px; object-fit: cover; float: right;  margin-top: -10px; " src=${Close}
                  alt="Edit"></img>
          </a>
        </div> 
      </div>
      
      
      <div style="width: 100%; display: flex;position: relative; z-index: 111;">
          <div style="width: 55%;">
              <h6 class="info-box-head-date">Created: <span class="info-box-head-date">${formattedDate}</span></h6>
              <h6 class="info-box-head">Elev: <span class="info-box-span">${altitudeValue}</span></h6>
              <h6 class="info-box-head">Lattitude: <span class="info-box-span">${latitude}</span></h6>
              <h6 class="info-box-head">Longitude: <span class="info-box-span">${longitude}</span></h6>                                                
              <div style="display:flex; margin-top:10px;margin-right: 10px;">
                  <div
                      style="width: 50px; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="shareButton">
                          <div class="info-window-bottons" >
                              <img style="width: 50%; height: 50%; object-fit: cover;" src=${Shared}></img>
                          </div>
                      </a>
                      <p>Share</p>
                  </div>
                  <div
                      style="width: 50px; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="editButton">
                          <div class="info-window-bottons">
                              <img style="width: 50%; height: 50%; object-fit: cover;" src=${Edit} alt="Edit"></img>
                          </div>
                      </a>
                      <p>Edit</p>
                  </div>
                  <div
                      style="width: 50px; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="deleteButton">
                          <div class="info-window-bottons">
                              <img style="width: 50%; height: 50%; object-fit: cover;" src=${Delete}></img>
                          </div>
                      </a>
                      <p>Delete</p>
                  </div>
              </div>                                                                        
          </div>                        
          <div style="
              width: 115px;
              height: 125px;
              margin-top:10px;
              display: flex;
              justify-content: center;
              align-items: ${photo ? 'center' : 'normal'};">
              ${photo ?
        ` <img id="imageView"
                  style="width: 100%; height: 100%; cursor:${photo && photo.imageUrl ? 'pointer' : 'default'}; padding:2px ; box-shadow:0px 0px 3px rgb(255 220 220 / 50%);" 
                  src=${photo && photo.imageUrl ? photo.imageUrl : Delete}></img>
        `
        :

        `<svg class="info-marker-default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Define the clipping path for the circle -->
                  <defs>
                      <clipPath id="circleClip">
                          <circle cx="8" cy="6" r="5" />
                      </clipPath>
                  </defs>
                  <rect width="16" height="16" id="icon-bound" fill="none"></rect>
                  <path
                      d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
                      fill='${colorMarker ? colorMarker : ' #ffffff'}'></path>
                  <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
                  <!-- Image inside the circle with clipping path -->
                  <image xlink:href=${imageUrl ? imageUrl
          : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} x="4" y="1.5"
                      width="8" height="8" clip-path="url(#circleClip)"></image>
              </svg>`
      }
          
          </div>
      </div>                                                  
      <div class="triangle-container">
          <div class="triangle-shape" style="margin-bottom: 3px;"></div>
      </div>           
      `;
    // Append the container to the desired parent element
    document.body.appendChild(container);

    const reactComponentContainer = container.querySelector('#my-react-component-container');

    if (reactComponentContainer) {
      const root = createRoot(reactComponentContainer); // For React 18 and later
      root.render(<LayerNodeDescription value={value.name} parent={true} />);
    }

    // Add CSS for the triangle shape
    const style = document.createElement('style');
    style.innerHTML = `
      .triangle-shape {
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 30px solid #000000;
        transform: rotate(225deg);
      }
        
      .triangle-container {
        justify-content: center;
        align-items: center;
        position: absolute;
        left: -10px;
        bottom: -15px;
      }

      .gm-style .gm-style-iw-c {
        padding: 0px !important;
        left:${marker && (marker.markerType.usageFlag == 3) ? '160px' : '150px'} !important;
        top: 3px !important;
      }
      `;

    document.head.appendChild(style);

    const dynamicValue = value.name;
    const encodedValue = encodeURIComponent(dynamicValue);
    let markerDetails = value?.markerType?.name ? encodeURIComponent(value.markerType.name) : ''
    // Add event listeners to the buttons
    container.querySelector('#editButton').addEventListener('click', editFunctionCb);
    container.querySelector('#deleteButton').addEventListener('click', () => deleteFunctionCb(value));
    container.querySelector('#close').addEventListener('click', closeFunctionCb);
    container.querySelector('#shareButton').addEventListener('click', () => sendEmail(value.latitude, value.longitude, encodedValue, markerDetails));
    photo && container.querySelector('#imageView').addEventListener('click', () => showAlert(photo, formattedDate));


    if (marker && (marker.markerType.usageFlag == 3)) {
      container.querySelector('#editHuntWind').addEventListener('click', editHuntFunctionCb);
    }
    // Append the container to the body
    document.body.appendChild(container);

    return container;
  };

  if (infoWindow) {
    infoWindow.infoWindowFunction && infoWindow.infoWindowFunction.close()
  }

  newInfoWindow = new google.maps.InfoWindow({
    content: infoWindowContent(marker || photo),
    disableAutoPan: true, // Prevents the info window from panning the map to fully display itself
    pixelOffset: new google.maps.Size(0, -10), // Adjusts the position of the info window
    maxWidth: 544, // Maximum width of the info window
  });

  if (newInfoWindow) {
    dispatchFunction && dispatchFunction(newInfoWindow)
  }

  function closeFunctionCb() {
    closeFunction(newInfoWindow)
  }

  newInfoWindow.open(mapReference, mapObj ? mapObj : mapPhotoObj);

  newInfoWindow && updateInfoWindow(newInfoWindow)
}

// export const buildContent = (url, color) => {
//   const hasSpaces = url.includes(' ');
//   // If there are spaces, replace them with %20
//   let colorMarker
//   if (color) {
//     if (color.length <= 6) {
//       colorMarker = color[0] == '#' ? color : '#' + color
//     } else {
//       colorMarker = color[0] == '#' ? color : '#' + color.substring(color.length == 7 ? 1 : 2)
//     }
//   } else {
//     colorMarker = '#9ecc3b'
//   }
//   const imageUrl = hasSpaces ? url.replace(/\s/g, '%20') : url;
//   const content = document.createElement("div");
//   content.classList.add("property");
//   content.innerHTML = `
//       <svg class="default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
//           xmlns:xlink="http://www.w3.org/1999/xlink">
//           <!-- Define the clipping path for the circle -->
//           <defs>
//               <clipPath id="circleClip">
//                   <circle cx="8" cy="6" r="5" />
//               </clipPath>
//           </defs>
//           <rect width="16" height="16" id="icon-bound" fill="none"></rect>
//           <path
//               d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
//               fill='${colorMarker}'></path>
//           <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
//           <!-- Image inside the circle with clipping path -->
//           <image
//           srcset="
//       ${imageUrl ? imageUrl.replace('.png', '@2x.png') : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} 2x,
//       ${imageUrl ? imageUrl : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} 1x"

//           xlink:href=${imageUrl ? imageUrl : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} x="4.5" y="2" width="7" height="7" clip-path="url(#circleClip)"></image>
//       </svg>
//     `;
//   return content;
// }

export const buildContent = (url, color) => {
  const hasSpaces = url.includes(' ');
  let colorMarker;
  if (color) {
    if (color.length <= 6) {
      colorMarker = color[0] == '#' ? color : '#' + color;
    } else {
      colorMarker = color[0] == '#' ? color : '#' + color.substring(color.length == 7 ? 1 : 2);
    }
  } else {
    colorMarker = '#9ecc3b';
  }

  const imageUrl = hasSpaces ? url.replace(/\s/g, '%20') : url;
  const content = document.createElement("div");
  content.classList.add("property");
  content.innerHTML = `
      <svg class="default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Define the clipping path for the circle -->
          <defs>
              <clipPath id="circleClip">
                  <circle cx="8" cy="6" r="5" />
              </clipPath>
          </defs>
          <rect width="16" height="16" id="icon-bound" fill="none"></rect>
          <path
              d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
              fill='${colorMarker}'></path>
          <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
          <!-- Image inside the circle with clipping path -->
          <image xlink:href=${imageUrl ? imageUrl
      : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} x="4" y="1.5" width="8"
              height="9" clip-path="url(#circleClip)"></image>
      </svg>
  `;
  return content;
}

export const formatNumberWithCommas = (number) => {
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const calculateCircleProperties = (geoJsonString, userPreferences) => {
  let geoJson;
  try {
    geoJson = JSON.parse(geoJsonString);
  } catch (error) {
    console.error("Invalid GeoJSON string:", error);
    return { radStr: '0', areaStr: '0' };
  }
  if (!geoJson || !geoJson.features || geoJson.features.length === 0) {
    return { radStr: '0', areaStr: '0' };
  }
  const radius = geoJson.features[0].properties.radius;
  if (typeof radius !== 'number' || radius <= 0) {
    return { radStr: '0', areaStr: '0' };
  }
  let formattedRadius;
  let area;
  let scale = userPreferences.units === 'imperial' ? 0.000247105 : 0.0001
  const denom = userPreferences.units === 'imperial' ? radius < 402 ? .328074 : 1609.344 : 1000
  if (userPreferences.units === 'imperial') {
    formattedRadius = `${(radius / denom).toFixed(2)} mi`; // Convert feet to miles
    const areaInSquareFeet = Math.PI * Math.pow(radius, 2);
    area = areaInSquareFeet * scale; // 1 acre = 43,560 square feet
  } else {
    formattedRadius = `${(radius / 1000).toFixed(2)} km`;
    const areaInSquareMeters = Math.PI * Math.pow(radius, 2);
    area = areaInSquareMeters * 0.0001; // 1 hectare = 10,000 square meters
  }
  const areaStr = `${formatNumberWithCommas(area.toFixed(2))} ${userPreferences.units === 'imperial' ? 'ac' : 'ha'} `;
  return { radStr: formattedRadius, areaStr };
};


function getLength(shape, units, ignoreCount = 0) {
  const denom = units === 'imperial' ? 1609.344 : 1000,
    coords = shape.getPath().getArray().slice(0, shape.getPath().getLength() - ignoreCount)
  let length = 0
  coords.forEach((pt, idx) => {
    if (idx > 0) {
      length += google.maps.geometry.spherical.computeDistanceBetween(pt, coords[idx - 1]) / denom
    }
  })
  return length
}

function getArea(shape, units, ignoreCount = 0) {
  if (shape) {
    const coords = shape.getPath().getArray().slice(0, shape.getPath().getLength() - ignoreCount),
      scale = units === 'imperial' ? 0.000247105 : 0.0001,
      computedArea = Math.round(google.maps.geometry.spherical.computeArea(coords) * scale * 100) / 100
    return computedArea
  }
}

export const calculatePolyProperties = (mapObj, userPreferences) => {
  let polyPerimeter = getLength(mapObj, userPreferences.units, 0)
  let polyArea = getArea(mapObj, userPreferences.units, 0)
  if (userPreferences.units == 'imperial') {
    polyPerimeter = formatNumberWithCommas(polyPerimeter.toFixed(2)) + ' ' + ' mi'
    polyArea = formatNumberWithCommas(polyArea.toFixed(2)) + ' ' + 'ac'
  }
  else {
    polyPerimeter = formatNumberWithCommas(polyPerimeter.toFixed(2)) + ' ' + ' km'
    polyArea = formatNumberWithCommas(polyArea.toFixed(2)) + ' ' + 'ha'
  }
  return { polyArea: polyArea, polyPerimeter: polyPerimeter };
}

function getElevationGain(shape, token, ignoreCount = 0) {
  const coords = shape.getPath().getArray().slice(0, shape.getPath().getLength() - ignoreCount),
    eles = coords.map(coord => elevation.getElevation(coord.lat(), coord.lng(), token))
  return new Promise((resolve, reject) => {
    Promise.all(eles)
      .then(res => {
        let gain = 0
        if (res.length > 1) {
          gain = 0
          for (let i = 0; i < res.length - 1; i++) {
            if (res[i + 1] > res[i]) {
              gain = gain + res[i + 1] - res[i];
            }
          }
        }
        resolve(gain)
      })
      .catch(err => {
        console.error('Could not fetch elevations:', err)
        reject()
      })
  })
}


export const calculateLineProperties = async (mapObj, token, userPreferences) => {
  const scale = userPreferences.units === 'imperial' ? 3.28084 : 1;
  const gainUnits = userPreferences.units === 'imperial' ? 'ft' : 'm'
  const lenUnits = userPreferences.units === 'imperial' ? 'mi' : 'km'

  let lineLength = getLength(mapObj, userPreferences.units, 0)
  let elevationGain = await getElevationGain(mapObj, token, 0).then(res => { return res }).catch((err) => { console.log(err, '=======>err'); return err })

  let lengthString = formatNumberWithCommas(lineLength.toFixed(2)) + ' ' + lenUnits
  let gain = (elevationGain * scale)
  let gainString = formatNumberWithCommas(gain.toFixed(0)) + ' ' + gainUnits

  return { lineElevation: gainString, lineLength: lengthString };
}